import {useEffect, useState} from 'react';
import {useQuestionnaireApi} from '../api/demographics';
import {useNavigate} from 'react-router-dom';

const enablePrivateAccess = true;

/**
 * Component to control access to the symptom checker based on questionnaire data.
 *
 * @param {Object} props - React props containing the element to be rendered.
 * @param {JSX.Element} props.element - The JSX element to be rendered if access is granted.
 * @returns {JSX.Element} The JSX element for controlling symptom checker access.
 */
export const SymptomCheckerAccess = ({element}) => {
  const [renderElement, setRenderElement] = useState(null);
  const questionnaireApi = useQuestionnaireApi();
  const navigate = useNavigate();

  useEffect(() => {
    if (!enablePrivateAccess) {
      setRenderElement(element);
      return;
    }
    const fetchData = async () => {
      const demographicsDataReq = await questionnaireApi.getQuestionnaire();

      if (Object.keys(demographicsDataReq).length === 0) {
        navigate(-1);
        return;
      }

      setRenderElement(element);
      return;
    };
    fetchData();
  }, [questionnaireApi, navigate, element]);

  // Render the element conditionally
  return renderElement;
};
